import { literal_price_with_check_zero_fractional_part } from 'src/library/minigame_client/ui/common/ui'

export default class UiSceneList extends PIXI.Container {
    constructor(configGame) {

        super();

        let self = this;

        const packFolder = configGame.packFolder;

        const config = configGame.UiSceneList;
        this.config = config;

        this.list = [];

        // all outside of mask is cut
        let mask = new PIXI.Graphics();
        mask.beginFill(0xFFFFFF);
        mask.drawRect(0, config.startY - (config.maxListSize - 2) * config.offY, 1980, (config.maxListSize - 2) * config.offY);
        mask.endFill();
        this.addChild(mask);

        for (let i = 0; i < config.maxListSize; ++i) {
            this.layer = new PIXI.Container();
            this.list.push(this.layer);
            this.addChild(this.layer);
            this.layer.mask = mask;

            let loseOrel    = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "list/lose_orel.png"]);
            let loseReshka  = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "list/lose_reshka.png"]);
            let winOrel     = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "list/win_orel.png"]);
            let winReshka   = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "list/win_reshka.png"]);

            loseOrel.position.set(72, 0);
            loseReshka.position.set(70, 0);

            let label       = new PIXI.extras.BitmapText("", {font: config.label.font.name});
            label.position = config.label.pos;
            label.align = config.label.font.align;
            label.anchor = config.label.font.anchor;

            let labelCurrency = new PIXI.extras.BitmapText("", {font: config.labelCurrency.font.name});
            labelCurrency.position = config.labelCurrency.pos;
            labelCurrency.align = config.labelCurrency.font.align;
            labelCurrency.anchor = config.labelCurrency.font.anchor;

            this.layer.addChild(loseOrel);
            this.layer.addChild(loseReshka);
            this.layer.addChild(winOrel);
            this.layer.addChild(winReshka);
            this.layer.addChild(label);
            this.layer.addChild(labelCurrency);
            this.layer.position.set(config.layer.pos.x, config.startY - config.offY - i * config.offY);
            this.layer.visible = false;

            this.layer.node = {winOrel: winOrel, loseOrel: loseOrel, winReshka: winReshka, loseReshka: loseReshka,
                label: label, labelCurrency: labelCurrency};
        }
    };

    terminate() {
        this.removeChildren();
        this.destroy();

        for (let obj of this.list) {
            if (obj.moveTween) obj.moveTween.stop();
            obj = null;
        }
        this.list = null;
    }

    addResult(win, isOrel, precision, delimiter, currency) {

        let self = this;

        let getNextLayer = function () {
            let temp = self.list.pop();
            temp.position.y = self.config.startY;
            self.list.unshift(temp);

            let layer = self.list[0];
            if (layer.moveTween) layer.moveTween.stop();

            return layer;
        };

        let layerResult = getNextLayer();
        let layerWin = getNextLayer();
        this._setTextResult(win, isOrel, precision, delimiter, currency, layerResult, layerWin);

        layerWin.position.y += this.config.offY;
        let offY = 2 * this.config.offY;

        for (let i = 0; i < this.list.length; ++i) {
            let layer = this.list[i];
            let targetY = layer.position.y - offY;
            (function (indCopy) {
                layer.moveTween = new TWEEN.Tween(layer.position)
                    .to({y: targetY}, 300)
                    .start();
            })(i);
        }
    }

    setHistory (history) {
        let i = 0, j = 0;
        while (i < history.length && j < this.list.length) {
            let layerWin = this.list[j++];
            let layerResult = this.list[j++];
            this._setTextResult(history[i].win, history[i].isOrel, history[i].precision, history[i].delimiter, history[i].currency, layerResult, layerWin);
            i++;
        }
    }

    _setTextResult (win, isOrel, precision, delimiter, currency, layerResult, layerWin) {
        let clearTextResult = function (layer) {
            let node = layer.node;
            for (let property in node) {
                if (node.hasOwnProperty(property)) {
                    node[property].visible = false;
                }
            }

            layer.visible = true;
        };

        clearTextResult(layerResult);
        clearTextResult(layerWin);

        let nodeResultText = layerResult.node;
        if (isOrel)
            (win > 0 ? nodeResultText.winOrel : nodeResultText.loseOrel).visible = true;
        else
            (win > 0 ? nodeResultText.winReshka : nodeResultText.loseReshka).visible = true;

        if (win > 0) {
            let nodeWin = layerWin.node;

            nodeWin.label.text = literal_price_with_check_zero_fractional_part(win, precision, delimiter);
            nodeWin.label.visible = true;

            nodeWin.labelCurrency.text = currency;
            nodeWin.labelCurrency.visible = true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/uiscene_list.es6